/**
 * This provides room for 9 middle page links, plus the two ellipses
 * and the first and last page.
 */
export const PAGE_LINK_COUNT_MAXIMUM = 13;

/**
 * This provides room for 15 middle page links, plus the two ellipses
 * and the first and last page.
 */
export const MOBILE_PAGE_LINK_COUNT_MAXIMUM = 15;

/**
 * This provides room for 1 middle page links, plus the two ellipses
 * and the first and last page.
 */
export const PAGE_LINK_COUNT_MINIMUM = 5;

/**
 * This is the minimum page index that the middle page links can go down to.
 * The middle page links refer to all the pages between the two ellipses ("...").
 */
export const MIDDLE_PAGE_LINK_LOWER_BOUND = 2;

/**
 * Pagination data, usually returned from a backend api, containing
 * information on the current page number, the size of the page, the
 * total number of pages, and the total number of results.
 */
export interface IPaginationData {
  /**
   * Number of the currently active page.
   */
  page_number?: number;
  /**
   * Number of items per page
   */
  page_size?: number;
  /**
   * Number of pages total.
   */
  page_count?: number;
  /**
   * Total number of results (the final page may be smaller than the page size).
   */
  total_results?: number;
}
